export enum RoleName {
    TREAdmin = "TREAdmin",
    TREUser = "TREUser"
}

export enum WorkspaceRoleName {
    WorkspaceOwner = "WorkspaceOwner",
    WorkspaceResearcher = "WorkspaceResearcher",
    AirlockManager = "AirlockManager"
}

export enum EnvironmentsName {
    DEVELOPMENT = "cprddev",
    TEST = "cprdtest",
    PRODUCTION = "cprdprod"
}
